import React from 'react';
import { useStore } from "../teafuljs/store"
import { getTranslation } from "../scripts/getTranslation"
import { makeStyles } from "@material-ui/core/styles"

const useStyles = makeStyles(theme => ({
  categoryTitle: {
    display: 'flex',
    margin: "20px 0",
    paddingTop: 20,
    paddingBottom: 10,
    borderBottom: `2px solid ${theme.palette.primary.main}`,
  },
  title: {
    display: "block",
    margin: 'auto 0'
  },
}))

export default ({ translationKey, textId, sourceImage }) => {
  const classes = useStyles()
  const translations = useStore.translations()[0]
  const language = useStore.language()[0]
  return (
    <h2 key={`${translationKey}-${textId}`} className={classes.categoryTitle}>
      {sourceImage ? (
        <img
          style={{ height: 40, width: 40, margin: "auto 0" }}
          src={require(`../../static/images/${sourceImage}.png`)}
          alt={textId}
        />
      ) : null}
      <span className={classes.title}>
        {getTranslation(translations, language, translationKey, textId)}
      </span>
    </h2>
  )
}